import React from "react"
import TableCell from "./TableCell"
import {scaleQuantile} from "d3-scale"

/**
 * The tablerows component will render the single table row based on the data and type property.
 */
export default function TableRow({
  columns,
  rowData,
  onRowClick,
  rowIndex,
  selectedRowId,
  hoveredColumnkey,
  isHover,
  selectableRows,
}) {
  const getClassName = (value, conditionalCellStyles = []) => {
    let className

    if (conditionalCellStyles.length) {
      conditionalCellStyles.forEach((exp) => {
        if (!exp.when || typeof exp.when !== "function") {
          throw new Error(
            '"when" must be defined in the conditional style object and must be function'
          )
        }
        let condition = exp.type === "index" ? rowIndex : value
        // evaluate the field and if true return the class to be applied
        if (exp.when(condition)) {
          className = exp.class || ""
        }
      })
    }
    return className
  }

  const getBackgroundColor = (value, conditionalCellColor = {}) => {
    if (Object.keys(conditionalCellColor).length > 0) {
      const colorScale = scaleQuantile()
        .domain(conditionalCellColor.domain)
        .range(conditionalCellColor.colorRange)

      return value ? colorScale(value) : ""
    } else {
      return ""
    }
  }
  const domRow = columns.map((col) => {
    let cellContent
    if (col.type === "custom") {
      cellContent = col.content
    } else {
      cellContent = rowData[col.key]
    }
    return (
      <TableCell
        colKey={col.key}
        cellData={cellContent}
        customStyles={{
          backgroundColor: getBackgroundColor(rowData[col.key], col.conditionalCellColor),
        }}
        className={
          getClassName(rowData[col.key], col.conditionalCellStyles) +
          (col.class ? " " + col.class : "") +
          " " +
          col.key
        }
        selected={
          !isHover && hoveredColumnkey && hoveredColumnkey === col.key ? true : false
        }
        onCellClick={col.onCellClick}
        rowData={rowData}
        key={`${rowData["id"]}-${col.key}`}
      />
    )
  })

  return (
    <tr
      key={rowData["id"]}
      id={rowData["id"]}
      onClick={() => onRowClick(rowData)}
      data-testid="tr"
      className={
        "row" +
        (selectedRowId === rowData["id"] ? "-selected" : "") +
        (selectableRows ? " hovered-row" : "")
      }
    >
      {domRow}
    </tr>
  )
}
